<template>
  <div>
    <div v-show="isModoLista">
      <new-items-clientes-vue title="CLIENTES" placeholderNm="Cód. Cliente, Fantasia, Razão, CNPJ e Endereço" placeholderCid="Cidade"></new-items-clientes-vue>
      <table-clientes-vue title="Clientes"></table-clientes-vue>
    </div>

    <div v-show="!isModoLista">
      <table-edit-clientes-vue title="EDITAR CLIENTE"></table-edit-clientes-vue>
    </div>
  </div>
</template>

<script>
  import App from '@/App'
  import NewItemsClientesVue from '@/components/items/NewItemsClientesVue'
  import TableClientesVue from '@/components/items/TableClientesVue'
  import TableEditClientesVue from '@/components/items/TableEditClientesVue'
  import { broadcastServer, modo } from '@/main'

  export default {
    name: 'ClientesVue',
    components: {
      App,
      NewItemsClientesVue,
      TableClientesVue,
      TableEditClientesVue
    },
    data () {
      return {
        isModoLista: true
      }
    },
    created () {
      window.addEventListener('beforeunload', this.toTopOnRefresh)
      // console.log('modo: ' + JSON.stringify(modo.LISTA))
      broadcastServer.$on('pageEditClientes', parametro => {
        window.scrollTo(0, 0)
        this.isModoLista = (parametro.modo === modo.LISTA)
      })
    },
    methods: {
      toTopOnRefresh: function toTopOnRefresh (event) {
        window.scrollTo(0, 0)
      }
    }
  }
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/ClientesVue.vue